import React from "react";
import { Box, Typography } from "@material-ui/core";

const HaklaiLockNotice = ({ classes, message }) => {
  if (!message) return null;

  return (
    <Box className={classes.lockNotice}>
      <Typography variant="body2" className={classes.lockNoticeText}>
        {message}
      </Typography>
    </Box>
  );
};

export default React.memo(HaklaiLockNotice);
